<template>
    <DCard
        padding
    >
        <DRow class="pb-2">
            <DCol>
                <DTag
                    color="primary"
                    :label="selectedContracts + ' ' + __('customers.terminate_bankruptcy_contracts.selected_contracts')"
                />
            </DCol>
        </DRow>
        <DRow>
            <DCol>
                <DTable
                    :items="contractsData.items || []"
                    :fields="fields"
                    :header="true"
                >
                    <template #checkbox-header>
                        <DFormCheck
                            id="contract_checkbox_all"
                            v-model="checkAllContracts"
                            inline
                            @update:modelValue="updateAllCheckboxes"
                        />
                    </template>
                    <template #checkbox="{item}">
                        <td>
                            <DFormCheck
                                v-if="item.id"
                                :id="`contract_${item.id}`"
                                :custom="true"
                                :checked="form.contractIds.includes(item.id)"
                                @click="updateCheckedContracts(item)"
                            />
                        </td>
                    </template>
                    <template #id="{item}">
                        <td v-if="userPermissions.includes('contract.view')">
                            <Link :href="contractShowRoute(item.id)">
                                {{ item.id }}
                            </Link>
                        </td>
                        <td v-else>
                            {{ item.id }}
                        </td>
                    </template>
                    <template #status="{item}">
                        <td>
                            <DTag
                                :label="item.status"
                                color="primary"
                            />
                        </td>
                    </template>
                </DTable>
                <DPagination
                    v-if="contractsData.last_page > 1"
                    :active-page="contractsData.current_page"
                    :pages="contractsData.last_page"
                    align="center"
                    @update:activePage="changePage"
                />
            </DCol>
        </DRow>
        <DFabs>
            <DFab
                icon="close"
                color="danger"
                :disabled="!form.contractIds.length"
                :label="__('customers.terminate_bankruptcy_contracts.terminate_bankruptcy_contracts')"
                @click="openConfirmationModal()"
            />
            <DFab
                icon="close"
                color="secondary"
                @click="cancelRoute()"
            />
        </DFabs>
        <DModal
            v-if="showConfirmationModal"
            :show="showConfirmationModal"
            :title="__('customers.terminate_bankruptcy_contracts.confirm_modal.title')"
            :message="__('customers.terminate_bankruptcy_contracts.confirm_modal.message', { 'number': selectedContracts })"
            is-confirm
            is-error
            @close="closeConfirmationModal()"
            @confirm="submit()"
        />
    </DCard>
</template>

<script>
import CustomerBase from '~@/Pages/Customers/Base'
import App from '~@/App.vue'
import { useForm, router, usePage } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'
import { __ } from '~@/Composables/translation'
import { computed, ref } from 'vue'
import axios from 'axios'

export default {
    layout: [App, CustomerBase]
}

</script>

<script setup>

const props = defineProps({
    contracts: {
        type: Array,
        default: () => {
            return []
        }
    },
    errors: {
        type: Object,
        default: () => {
            return {}
        }
    },
    customer: {
        type: Object,
        default: () => {
            return {}
        }
    }
})

const showConfirmationModal = ref(false)
const checkAllContracts = ref(false)
const contractsData = ref(props.contracts)

const fields = [
    { key: 'checkbox', label: '' },
    { key: 'id', label: __('customers.terminate_bankruptcy_contracts.id') },
    { key: 'product', label: __('customers.terminate_bankruptcy_contracts.product') },
    { key: 'product_group', label: __('customers.terminate_bankruptcy_contracts.product_group') },
    { key: 'status', label: __('customers.terminate_bankruptcy_contracts.status') },
    { key: 'start_date', label: __('customers.terminate_bankruptcy_contracts.start_date') },
]

const form = useForm({
    contractIds: []
})

const selectedContracts = computed(function () {
    return form.contractIds.length
})

const userPermissions = computed(() => usePage().props.auth.permissions)

function updateCheckedContracts (contract) {
    const contractIndex = form.contractIds.indexOf(contract.id)

    if (contractIndex < 0) {
        form.contractIds.push(contract.id)

        return
    }

    checkAllContracts.value = false
    form.contractIds = form.contractIds.filter(function (item) {
        return contract.id !== item
    })
}

function updateAllCheckboxes (value) {
    form.contractIds = []

    if (value === false) {
        return
    }

    form.contractIds = contractsData.value.allContractIds
}

function openConfirmationModal () {
    showConfirmationModal.value = true
}

function closeConfirmationModal () {
    showConfirmationModal.value = false
}

function contractShowRoute (contractId) {
    return route('customers.customers.contracts.show', { customer: props.customer.id, contract: contractId })
}

function cancelRoute () {
    return router.get(route('customers.customers.show', { customer: props.customer.id }))
}

function submit () {
    form.post(route('customers.customers.store_terminate_bankruptcy_contracts', {
        customer: props.customer.id,
    }), {}, {
        onSuccess: () => {
            this.showConfirmationModal = false
        }
    })
}

function changePage (selectedPage) {
    const params = {
        customer: props.customer.id,
        page: selectedPage,
    }

    axios.get(route('customers.customers.terminate_bankruptcy_contracts', params))
        .then(response => {
            contractsData.value = response.data
        })
}
</script>
